<template>
    <div class="fixed-container d-inline-flex btn-lang-es">
        <router-link :to="{name: 'en'}">
            <button type="submit" class="btn btn-sm btn-outline-light mx-0 rounded-0 border-0">
                <img src="../assets/estados-unidos.svg" width="25" alt="">
            </button>
        </router-link>
    </div>
    <!-- rappi and pedidosya -->
    <div class="container-fluid ">
        <div class="row justify-content-center">
            <div class="col-10">
                <div class="row">
                    <div class="col-md-12 h-bar">
                        <h2 class="title-bar text-center">Especial de Halloween. 👻🍕</h2>
                        <small class="mb-2 d-flex justify-content-center text-normal">Haz tu delivery de 5pm a 11pm.</small>
                        <div class="d-flex justify-content-center">
                            <a target="_blank" href="https://api.whatsapp.com/send?phone=51919199944&text=Hola%20quisiera%20pedir%20una%20pizza"
                                class="btn btn-outline-dark rounded-0 subtitle mx-2 text-normal">Whatsapp 919 199 944</a> <span class="fw-light"> </span>

                          <a target="_blank" href="https://www.tiktok.com/@pizza_boom_deli"
                             class="btn btn-outline-dark rounded-0 subtitle mx-2 text-normal"> 🍕Ver Especial Halloween 👻</a> <span class="fw-light"> </span>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
    <!-- alergernos -->
    <allergensComponent
    title="INGREDIENTES"
    subtitle="NUESTROS TOPPINGS"
    :allergens="getters_allergens_es"
    ></allergensComponent>


    <categorynewComponent
    v-if="!store.v_success"
    :categories="getters_es" 
    :allergens="getters_allergens_es" 
    id_beer="9"
    id_wine="5"
    btn_name="VER MÁS"
    ></categorynewComponent>
    
    <boton-ayahuasca
        style="display: none"
    :title="'Carta Ayahuasca'"
    :subtitle="'Ver más'"
    :categories="getters_ayahuasca_es"
    ></boton-ayahuasca>
  <!--Creacion -->

</template>
<script>

import { onMounted,computed, onUpdated } from "vue";
import {useStore} from "vuex";

import categorynewComponent from '@/components/web/categorynewComponent.vue'
import allergensComponent from "@/components/web/allergensComponent.vue";
import botonAyahuasca from "@/components/web/botonAyahuasca.vue";

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default {
    name: 'esView',
    components:{
        allergensComponent,categorynewComponent,botonAyahuasca
    },
    setup(){
        const store = useStore();

        const getters_es = computed(() => store.getters.getters_es)
        //const v_categories =
        onMounted(() => {
            //console.log(getters_es.value.length)
            if (!store.state.v_success){
                store.dispatch('v_action_categories').then(() => {
               
                });//store
            }//if

            gsap.to(".btn-lang-es",{
            scrollTrigger: {
                trigger: ".btn-lang-es",
                start: "start+=150 center-=270",
                end: "bottom+=200 bottom",
                //markers: true,
                scrub:1,
                
            },
            opacity:0
            })

        })

        onUpdated(()=>{
          //console.log('lang actualizado')
        

         

        })

        return{
            store,
            getters_es,
            getters_allergens_es: computed(() => store.getters.getters_allergens_es),
        }
    }
}


</script>